// extracted by mini-css-extract-plugin
export default {"page_wrapper":"AboutUsPage_page_wrapper__QdRzd","main":"AboutUsPage_main__pDkJ2"};